import { render, staticRenderFns } from "./bottem-adv.vue?vue&type=template&id=949dfe46&scoped=true"
import script from "./bottem-adv.vue?vue&type=script&lang=js"
export * from "./bottem-adv.vue?vue&type=script&lang=js"
import style0 from "./bottem-adv.vue?vue&type=style&index=0&id=949dfe46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949dfe46",
  null
  
)

export default component.exports